import React from 'react'

import Accordion from 'components/Accordion'
import CircularProgress from 'components/CircularProgress'
import Form from 'components/Form'
import Review from 'components/Review'
import Typography from 'components/Typography'
import { TITLES } from 'helpers/filters'
import { revealSEOUrl } from 'helpers/SEOHelper'
import { STATUS } from 'helpers/spa'

import classes from './RatingStars.module.scss'

const RatingStars = ({ status, facet, onExpandClick, onItemClick }) => {
  const facetKey = 'rating_stars_ge'
  const selected = facet.find(value => value.selected)
  const loading = status === STATUS.loading

  return (
    <Accordion
      defaultExpanded
      detailsClassname={classes.accordionDetails}
      summary={<Typography variant="heading-sm">{TITLES[facetKey]}</Typography>}
      className="RatingStars"
      onExpandClick={onExpandClick({ facetKey })}
      summaryClassname={classes.accordionSummary}
    >
      {facet.length === 0 ? (
        <Typography>No filters available</Typography>
      ) : (
        <>
          {facet.map(facetType => (
            <Form.ControlLabel
              labelClassName={classes.radioButtonLabel}
              disabled={loading || facetType.count === 0}
              id={facetType.value}
              onClick={event => onItemClick(event, { facet: 'rating_stars_ge', href: revealSEOUrl(facetType.href) })}
              key={`radio-button-${facetType.value.toString()}`}
              labelComponent={
                <span className={classes.filterRow}>
                  <span>{facetType.label || <Review.Rating rating={facetType.value} withUp />}</span>
                  {loading ? (
                    <CircularProgress className={classes.circularProgress} color="inherit" size={16} />
                  ) : (
                    !facetType.selected &&
                    facetType.count !== null && <span className={classes.count}>({facetType.count})</span>
                  )}
                </span>
              }
              value={facetType.value.toString()}
              control={
                <Form.Radio
                  disabled={loading}
                  groupName="rating"
                  classes={{ colorPrimary: classes.radioColorPrimary }}
                  color="primary"
                  defaultChecked={selected?.value === facetType.value}
                  onClick={event =>
                    onItemClick(event, {
                      facet: 'rating_stars_ge',
                      href: revealSEOUrl(facetType.href),
                      value: facetType.value,
                    })
                  }
                />
              }
            />
          ))}
        </>
      )}
    </Accordion>
  )
}

export default RatingStars
